// extracted by mini-css-extract-plugin
export var form_cont = "contact-module--form_cont--8D5ds";
export var form_title = "contact-module--form_title--2kiF8";
export var input_cont = "contact-module--input_cont--3ApsA";
export var label = "contact-module--label--1Dubv";
export var text = "contact-module--text--2p0Nw";
export var error = "contact-module--error--2PLca";
export var message = "contact-module--message--3IiTV";
export var submit = "contact-module--submit--2s4Cw";